export default __webpack_public_path__ + "static/media/profile_placeholder.00dd3225.png";